import { useData } from "./DataContext.js";

import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from 'react-bootstrap/Popover';

export default function GroupTitle (props)
{
    const myGroup = false;
    const gData = useData();

    const groupID = props.groupID;
    const group = gData.group[groupID];
    const groupTitle = myGroup && groupID === gData.groupID ? "votre délégation" : group.title;

    let popover = (
	<Popover style={{ width: 300 }}>
	    <Popover.Header className="text-uppercase">{group.description}</Popover.Header>
	    <Popover.Body className="d-flex justify-content-between gap-2">
		{group.type === "admin" && (<span>Présidence</span>)}
		{group.type === "delegation" && (<span>Délégation</span>)}
		{group.type === "lobby" && (<span>Lobby</span>)}
		{group.type === "media" && (<span>Média</span>)}
		{group.voteCount > 0 && (<span>Nombre de voix : {group.voteCount}</span>)}
		{group.voteCount === 0 && (<span>Ne vote pas</span>)}
	    </Popover.Body>
	</Popover>
    );
    
    let groupSpan = (<Button variant={props.variant} className="text-uppercase px-2 py-0 pe-none">{groupTitle}</Button>);

    // TODO: correct flickering on Chrome
    groupSpan = (
	<OverlayTrigger placement="top" overlay={popover} transition={true} delay={{ show: 250, hide: 250 }}>
	    <span>
		{groupSpan}
	    </span>
	</OverlayTrigger>
    );

    /* if (props.determiner && ! (myGroup && props.groupID === gData.groupID)) groupSpan = (<><span>{group.determiner}</span>{groupSpan}</>);
     * if (props.voteCount && group.voteCount > 0) groupSpan = (<>{groupSpan} <span>[{group.voteCount}]</span></>); */

    return groupSpan;
}

GroupTitle.defaultProps = {
    variant: "outline-dark"
};
